import React from "react";
import { ClassNames } from "../../../helper";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FaArrowTrendDown } from "react-icons/fa6";

export function CohortCard({ data }) {
  const { name, value, image, percent, trend } = data;

  return (
    <div
      className="border-[#E5E5E5] border-2 border-solid card p-4 rounded-4 mx-2 my-2 basis-[250px]"
      style={{ boxShadow: "2px 5px 8px rgba(0,0,0,0.1)" }}
    >
      <div className="flex align-items-center justify-left mb-1">
        <img src={image} alt="" className="w-9 mr-2" />
        <p className="mb-1">{name}</p>
      </div>
      <div className="flex justify-between items-center gap-3 my-2">
        {typeof value !== 'undefined' && typeof percent !== 'undefined' ? (
          <>
            <p className="text-4xl">{value}</p>
            <div
              className={ClassNames(
                trend === "incr" ? "text-green-500" : "text-red-500",
                "flex justify-center items-center gap-3"
              )}
            >
              {trend === "incr" ? <FaArrowTrendUp /> : <FaArrowTrendDown />}
              <p>{percent}%</p>
            </div>
          </>
        ) : (
          <p className="text-4xl"> </p>
        )}
      </div>
    </div>
  );
}
